import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  ViewChild,
  Inject,
  forwardRef
} from '@angular/core';

import { 
  FormGroup,
  Validators 
} from '@angular/forms';

import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { isEqual, isNil, isEmpty } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  SeparatorModel,
  ButtonStyles 
} from './models/control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { ToolModel } from './models/tool';
import { TabItemModel, TabGroupModel } from './models/tab';
import { WidgetModel } from './models/widget';
import { FieldsetModel } from './models/fieldset';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootPrintPortalManager_ShellService, EModalSize, EToasterType, EToasterPosition } from './FootPrintPortalManager.shell.service';
import { FootPrintPortalManager_OperationService } from './FootPrintPortalManager.operation.service';
import { FootPrintPortalManager_DatasourceService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_FlowService } from './FootPrintPortalManager.flow.index';
import { FootPrintPortalManager_ReportService } from './FootPrintPortalManager.report.index';
import { FootPrintPortalManager_LocalizationService } from './FootPrintPortalManager.localization.service';
import { Language } from './localization.service';
import { $types } from './FootPrintPortalManager.types'

import { FootPrintPortalManager_inventory_lot_gridComponent } from './FootPrintPortalManager.inventory_lot_grid.component';
import { FootPrintPortalManager_inventory_tasks_gridComponent } from './FootPrintPortalManager.inventory_tasks_grid.component';
import { Inventory_total_available_amount_widgetComponent } from './Inventory.total_available_amount_widget.component';
import { Inventory_total_gross_weight_widgetComponent } from './Inventory.total_gross_weight_widget.component';
import { Inventory_total_packaged_amount_widgetComponent } from './Inventory.total_packaged_amount_widget.component';

@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => FootPrintPortalManager_inventory_lot_gridComponent),
    forwardRef(() => FootPrintPortalManager_inventory_tasks_gridComponent),
    forwardRef(() => Inventory_total_available_amount_widgetComponent),
    forwardRef(() => Inventory_total_gross_weight_widgetComponent),
    forwardRef(() => Inventory_total_packaged_amount_widgetComponent),
  ],
  selector: 'FootPrintPortalManager-single_lot_hub',
  templateUrl: './FootPrintPortalManager.single_lot_hub.component.html'
})
export class FootPrintPortalManager_single_lot_hubComponent implements OnInit, OnDestroy, OnChanges {

  inParams: { lotId: number } = { lotId: null };
  //#region Inputs
  @Input('lotId') set $inParams_lotId(v: number) {
    this.inParams.lotId = v;
  }
  get $inParams_lotId(): number {
    return this.inParams.lotId;
  }
  //#endregion Inputs

  @Input() showInDialog: boolean = false; 
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();  
  //#endregion Outputs
  hasToolbar: boolean = true;



  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  vars: { hubTitle?: string, hubDescription?: string } = { };
  //#endregion
  formGroup: FormGroup = new FormGroup({
  });
  
  toolbar = {
      edit: new ToolModel(new ButtonModel('edit', new ButtonStyles(null, null), false, 'Edit', 'ms-Icon ms-Icon--Edit')
    )
  };

  actionbar = {
  };

 filters = {
  };


  filtersets = {
};

    rootTabGroup = new TabGroupModel();
  
    subTabGroups = {
    };
  
    onTabSelected(event: MatSelectChange) {
      event.value.activate();
    }
  
    tabs = {
      inventory: new TabItemModel(
        this.rootTabGroup, 
        'Inventory', 
        ),
      tasks: new TabItemModel(
        this.rootTabGroup, 
        'Activity', 
        ),
    };
  
    //#region tabs inParams
    get $tabs_inventory_inventory_lot_grid_inParams_lotId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.inParams.lotId;
      
      return expr;
    }
  
    get $tabs_tasks_inventory_tasks_grid_inParams_lotId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.inParams.lotId;
      
      return expr;
    }
  
    //#endregion tabs inParams
  
    //#region tabs children
      @ViewChild('$tabs_inventory', { read: FootPrintPortalManager_inventory_lot_gridComponent }) $tabs_inventory: FootPrintPortalManager_inventory_lot_gridComponent;
      @ViewChild('$tabs_tasks', { read: FootPrintPortalManager_inventory_tasks_gridComponent }) $tabs_tasks: FootPrintPortalManager_inventory_tasks_gridComponent;
    //#endregion tabs children
    widgets = {
      total_available_amount_widget: new WidgetModel(),
      total_gross_weight_widget: new WidgetModel(),
      total_packaged_amount_widget: new WidgetModel(),
    };
  
    //#region widgets inParams
    get $widgets_total_available_amount_widget_inParams_lotId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.inParams.lotId;
      
      return expr;
    }
  
    get $widgets_total_gross_weight_widget_inParams_lotId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.inParams.lotId;
      
      return expr;
    }
  
    get $widgets_total_packaged_amount_widget_inParams_lotId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.inParams.lotId;
      
      return expr;
    }
  
    //#endregion widgets inParams
  
    //#region widgets children
      @ViewChild('$widgets_total_available_amount_widget', { read:  Inventory_total_available_amount_widgetComponent }) $widgets_total_available_amount_widget: Inventory_total_available_amount_widgetComponent;
      @ViewChild('$widgets_total_gross_weight_widget', { read:  Inventory_total_gross_weight_widgetComponent }) $widgets_total_gross_weight_widget: Inventory_total_gross_weight_widgetComponent;
      @ViewChild('$widgets_total_packaged_amount_widget', { read:  Inventory_total_packaged_amount_widgetComponent }) $widgets_total_packaged_amount_widget: Inventory_total_packaged_amount_widgetComponent;
    //#endregion widgets children


  get hubTitle(): string {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return $hub.vars.hubTitle;
  }

  get hubDescription(): string {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return $hub.vars.hubDescription;
  }

  constructor(
  private utils: UtilsService,
  private settings: SettingsValuesService,
  private shell: FootPrintPortalManager_ShellService,
  private datasources: FootPrintPortalManager_DatasourceService,
  private flows: FootPrintPortalManager_FlowService,
  private reports: FootPrintPortalManager_ReportService,
  private localization: FootPrintPortalManager_LocalizationService,
  private operations: FootPrintPortalManager_OperationService,
  ) { 
    this.$subscribeFormControlValueChanges();
    this.hasToolbar = !isEmpty(this.toolbar);

    //#region tabs tab init
    this.rootTabGroup.tabs = [
      this.tabs.inventory,
      this.tabs.tasks,
    ]; 
    //#endregion tabs tab init
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if(!this.$hasMissingRequiredInParams) {
      this.$init();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      }
    }
  }

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }
  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.lotId)) {
        this.$missingRequiredInParams.push('lotId');
      }
  }



  initialized = false;

  async $init() {
    this.title = 'Single Lot Hub';
    
    const $hub = this;
    const $utils = this.utils;


    await this.on_init();

    this.initialized = true;
  }

  private $subscribeFormControlValueChanges() {
  }
  close() {
    this.$finish.emit();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = Promise.resolve(null);
    
    // children
    if (skipChildren === false) {
      this.$refreshChildren(childToSkip);
    }

    return result;
  }

  $refreshChildren(childToSkip: string) {
    //#region widgets children
    if (childToSkip !== '$widgets_total_available_amount_widget') {
      if (!isNil(this.$widgets_total_available_amount_widget) && !this.widgets.total_available_amount_widget.hidden) {
        this.$widgets_total_available_amount_widget.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$widgets_total_gross_weight_widget') {
      if (!isNil(this.$widgets_total_gross_weight_widget) && !this.widgets.total_gross_weight_widget.hidden) {
        this.$widgets_total_gross_weight_widget.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$widgets_total_packaged_amount_widget') {
      if (!isNil(this.$widgets_total_packaged_amount_widget) && !this.widgets.total_packaged_amount_widget.hidden) {
        this.$widgets_total_packaged_amount_widget.refresh(true, false, null);
      }
    }
    //#endregion widgets children
    //#region tabs children
    if (childToSkip !== '$tabs_inventory') {
      if (!isNil(this.$tabs_inventory) && !this.tabs.inventory.hidden) {
        this.$tabs_inventory.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$tabs_tasks') {
      if (!isNil(this.$tabs_tasks) && !this.tabs.tasks.hidden) {
        this.$tabs_tasks.refresh(true, false, null);
      }
    }
    //#endregion tabs children
  }

  openImageViewer(imageSource: string) {
    this.shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $hub: FootPrintPortalManager_single_lot_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  
  
  const lot = (await $datasources.Lots.ds_get_lot_by_lotId.get({ lotId: $hub.inParams.lotId })).result;
  if ($utils.isDefined(lot)) {
  
      var expirationDate;
      var manufacturedDate;
      var receivedDate;
  
      // Apply date format
      if ($utils.isDefined(lot[0].VendorLot?.ExpirationDate) && $utils.isDefined($settings.FootPrintPortalManager.DateFormat)) {
          var dateFormat = $settings.FootPrintPortalManager.DateFormat;
          expirationDate = `Expiration Date ${$utils.date.format(lot[0].VendorLot?.ExpirationDate, dateFormat)}`;
      }
  
      if ($utils.isDefined(lot[0].VendorLot?.ManufactureDate) && $utils.isDefined($settings.FootPrintPortalManager.DateFormat)) {
          var dateFormat = $settings.FootPrintPortalManager.DateFormat;
          manufacturedDate = `Manufacture Date ${$utils.date.format(lot[0].VendorLot?.ManufactureDate, dateFormat)}`;
      }
  
      if (($utils.isDefined(lot[0].LastReceiveDate)) && $utils.isDefined($settings.FootPrintPortalManager.DateFormat)) {
          var dateFormat = $settings.FootPrintPortalManager.DateFormat;
          receivedDate = `Received Date ${$utils.date.format(lot[0].LastReceiveDate, dateFormat)}`;
      }
  
      $hub.title = `Lot ${lot[0].LookupCode}`;
  
      const title = `Lot ${lot[0].LookupCode} Vendor Lot ${lot[0].VendorLot?.LookupCode} Status ${lot[0].Status.Name} `;
  
     
          const description = `${receivedDate}  ${manufacturedDate}  ${expirationDate}   `;
          $hub.vars.hubDescription = description;
      
  
      $hub.vars.hubTitle = title;
  
  }
  
  
  //Apply operations
  await $hub.on_apply_operations();
  }
  on_edit_clicked(event = null) {
    return this.on_edit_clickedInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_edit_clickedInternal(
    $hub: FootPrintPortalManager_single_lot_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  
  const dialogResult = (await $shell.FootPrintPortalManager.openlot_editorDialog({lotId: $hub.inParams.lotId},'flyout'));
  const userConfirmed = dialogResult.confirm;
  
  if (userConfirmed) {
  
      await $hub.on_init();
      await $hub.refresh();
  }
  
  }
  on_apply_operations(event = null) {
    return this.on_apply_operationsInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_apply_operationsInternal(
    $hub: FootPrintPortalManager_single_lot_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  // Apply operations
  if (await $operations.FootPrintPortalManager.Disable_Lot_Activity.isAuthorized()){
      $hub.tabs.tasks.hidden = true;
  }
  
  if (await $operations.FootPrintPortalManager.Disable_Inventory_Activity.isAuthorized()){
      $hub.tabs.inventory.hidden = true;
  }
  
  if (await $operations.FootPrintPortalManager.Disable_Lot_Update.isAuthorized()){
      $hub.toolbar.edit.hidden = true;
  }
  
  
  
  }
  //#endregion private flows
}
